import React from 'react';
import { NavItem } from './NavItem';
export function Sidebar({
  activePage,
  onNavigate
}: {
  activePage: string;
  onNavigate: (page: string) => void;
}) {
  const isCaseStudy = activePage.startsWith('work/');
  return <div className="w-[300px] bg-[#111111] h-screen flex flex-col sticky top-0" data-id="element-175">
      <div className="h-[80px]" data-id="element-176" /> {/* Spacer for logo */}
      <nav className="flex-1 py-12 px-8 pt-[64px] pb-[64px]" data-id="element-177">
        <ul className="space-y-6 flex flex-col items-start" data-id="element-178">
          {isCaseStudy ? <li className="w-full" data-id="element-179">
              <NavItem label="Turning rules into a workflow brokers can clear" isActive={true} onClick={() => onNavigate('work/required-actions')} data-id="element-180" />
            </li> : <>
              <li className="w-full" data-id="element-181">
                <NavItem label="The problem behind the problem" isActive={activePage === 'complexity'} onClick={() => onNavigate('complexity')} data-id="element-182" />
              </li>
              <li className="w-full" data-id="element-183">
                <NavItem label="Turning research into decisions" isActive={activePage === 'research'} onClick={() => onNavigate('research')} data-id="element-184" />
              </li>
              <li className="w-full" data-id="element-185">
                <NavItem label="Building systems that last" isActive={activePage === 'systems'} onClick={() => onNavigate('systems')} data-id="element-186" />
              </li>
            </>}
        </ul>
      </nav>
      <div className="h-[72px]" data-id="element-187" /> {/* Spacer for copyright */}
    </div>;
}